import GoogleMapOverlay from '@/classes/GoogleMapOverlay.js'
import { useGoogleMapHelpers } from '@/composables/useGoogleMapHelpers.js';

let drawingManager;

export const useMapDrawingManager = () => {
  const googleMapHelpers = useGoogleMapHelpers();

  const init = ({div, map, callback}) => {
    if (!div) return;
    if (!map) return;

    drawingManager = drawingManager || new GoogleMapOverlay({ div, map, callback })
    drawingManager.setMap(map);

    googleMapHelpers.setMap(map)
  }

  const rebuild = ({div, map, callback}) => {
    drawingManager.setMap(null);

    drawingManager = new GoogleMapOverlay({ div, map, callback })
    drawingManager.setMap(map)
  }

  const remove = () => {
    if (!drawingManager) return;

    drawingManager.setMap(null);
    drawingManager = null;
  }

  const getCircleRadius = (points, radius) => {
    if (!points || !radius) return 0;

    if (!Array.isArray(points) || points.length === 1) {
      const centerPoint = Array.isArray(points) ? points[0] : points;

      return getCircleRadiusFromCenterPointAndRadius(centerPoint, radius)
    } else {
      return getCircleRadiusFromPoints(points);
    }
  }
  
  const getCircleRadiusFromPoints = (points) => {
    if (!points[0] || !points[1]) return 0;

    const point1 = points[0];
    const point2 = points[1];

    return googleMapHelpers.getDistanceBetweenPoints(point1, point2)
  }
  
  const getCircleRadiusFromCenterPointAndRadius = (centerPoint, radius) => {
    if (!centerPoint || !radius) return 0;

    const centerPointLatLon = googleMapHelpers.getLatLonFromPoint(centerPoint)

    const radiusLatLon = googleMapHelpers.getLatLonAtDistance({
      latLon: centerPointLatLon,
      distance: radius
    })

    const radiusPoint = googleMapHelpers.getPointFromLatLon(radiusLatLon)

    return googleMapHelpers.getDistanceBetweenPoints(centerPoint, radiusPoint)
  }

  return {
    init,
    rebuild,
    remove,
    map: () => drawingManager.map,
    getPointFromLatLon: (latLon) => drawingManager.getPointFromLatLon(latLon),
    getPointsFromLatLons: (latLons) => drawingManager.getPointsFromLatLons(latLons),
    getLatLonFromPoint: (point) => drawingManager.getLatLonFromPoint(point),
    getLatLonsFromPoints: (point) => drawingManager.getLatLonsFromPoints(point),
    getLatLonAtDistance: (settings) => googleMapHelpers.getLatLonAtDistance(settings),
    getDistanceBetweenLatLons: (latLon1, latLon2) => googleMapHelpers.getDistanceBetweenLatLons(latLon1, latLon2),
    getDistanceBetweenPoints: (point1, point2) => googleMapHelpers.getDistanceBetweenPoints(point1, point2),
    getHeadingBetweenLatLons: (latLon1, latLon2) => googleMapHelpers.getHeadingBetweenLatLons(latLon1, latLon2),
    getCircleRadius,
    getCircleRadiusFromCenterPointAndRadius
  }
}

